module.exports = __webpack_public_path__ + "static/media/cream_puffs.7e5bd92e.JPG";